import React, { Component } from 'react';

export default class Training extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="19.jpg upper upper__then">
        <div className="captions">
          Обработка даных о профессиональной переподготовке сотрудников и повышение квалификации
        </div>
        <table className="tg-second table__flour" style={{ float: 'none', fontSize: '0.75em' }}>
          <tr>
            <th className="tg-70w9" rowSpan="2">Постоянный состав ВУЗа</th>
            <th className="tg-70w9" rowSpan="2"><span>Всего по списку</span></th>
            <th className="tg-70w9" rowSpan="2">
              <span>Не повышали квалификацию свыше 3 лет</span>
            </th>
            <th className="tg-tegg" colSpan="2">Повысили квалификацию</th>
            <th className="tg-tegg" style={{ borderRight: '1px solid #5F2322' }} colSpan="7">Из них</th>
          </tr>
          <tr className="rotate__table">
            <td className="tg-tegg" style={{ display: 'table-cell' }}><span>По плану</span></td>
            <td className="tg-tegg"><span>Фактически</span></td>
            <td className="tg-tegg"><span>Обучение на ФППК (курсах) вузов Минобороны РФ</span></td>
            <td className="tg-tegg">
              <span>
                Обучение на ФППК (курсах, в центрах) др. федеральных органов исполнительной власти
              </span>
            </td>
            <td className="tg-tegg"><span>Стажировка в вузах Минобороны РФ</span></td>
            <td className="tg-tegg"><span>Стажировках в вузах других министерств</span></td>
            <td className="tg-tegg"><span>Стажировка в войсках</span></td>
            <td className="tg-tegg">
              <span>Стажировка в НИО, на предприятиях промышленности</span>
            </td>
            <td className="tg-tegg" style={{ borderRight: '1px solid #5F2322' }}><span>Участие в учениях</span></td>
          </tr>
          <tr className="creation">
            <td className="tg-w2ca" style={{ display: 'block', width: '176px', border: 'none' }}>1. Руководящий состав</td>
            <td className="tg-w2ca">27</td>
            <td className="tg-w2ca">7</td>
            <td className="tg-bp4j">11</td>
            <td className="tg-bp4j">5</td>
            <td className="tg-bp4j">1</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j">1</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j" />
            <td className="tg-bp4j">1</td>
            <td className="tg-yw4l">2</td>
          </tr>
          <tr className="creation">
            <td className="tg-bp4j">2. Преподавательский состав</td>
            <td className="tg-bp4j">512</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j">102</td>
            <td className="tg-bp4j">102</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j" />
            <td className="tg-bp4j">102</td>
            <td className="tg-bp4j">102</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j" />
            <td className="tg-yw4l" />
          </tr>
          <tr className="creation">
            <td className="tg-bp4j creation__padding_left">а) Военнослужащие</td>
            <td className="tg-bp4j">212</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j">48</td>
            <td className="tg-bp4j">48</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j" />
            <td className="tg-bp4j">48</td>
            <td className="tg-bp4j">48</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j" />
            <td className="tg-yw4l" />
          </tr>
          <tr className="creation">
            <td className="tg-bp4j creation__padding_left">б) Гражданский персонал</td>
            <td className="tg-bp4j">132</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j">12</td>
            <td className="tg-bp4j">12</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j">3</td>
            <td className="tg-bp4j" />
            <td className="tg-bp4j" />
            <td className="tg-bp4j">3</td>
            <td className="tg-bp4j">3</td>
            <td className="tg-yw4l">3</td>
          </tr>
        </table>
      </div>
    );
  }
}

